/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useSelector } from "react-redux";
import { selectCurrentModel } from "data/store/reducers/model";
// import { Logger } from "cms/utils/log/logger";

const useGetCurrentModel = () => {
    // Logger.info('Get Current Content:')
    // Logger.flush()
    const model = useSelector(selectCurrentModel);
    return model;
};

export { useGetCurrentModel };
